module.exports = __webpack_public_path__ + "static/meta-video-66338b563b886ed39b5c8073abef966b.jpg";